import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useTranslation } from 'react-i18next';
import FoundersContact from './FoundersContact';
import ContactUs from './ContactUs';
import MapSection from './MapSection';
import BarWithMaczek from './BarWithMaczek/index';
import BarWithElements from '../../components/BarWithElements';
import useWindowWidth from '../../hooks/useWindowWidth';
import BarWithSocialMedia from './BarWithSocialMedia';
import BarWithSocialMediaAndMaczek from './BarWithSocialMediaAndMaczek';


const Wrapper = styled.div`
  min-height: 100vh;
`;


const ContactLayout = () => {
  const windowSize = useWindowWidth();
  const themeContext = useContext(ThemeContext);
  const { t } = useTranslation();


  return (
    <Wrapper>
      {windowSize !== 0 && (
        <>
          <ContactUs />
          {windowSize >= themeContext.screenSizeWidthWithoutPx.large && (
            <BarWithMaczek>
              {t('orContactWithUs')}
            </BarWithMaczek>
          )}
          <FoundersContact />
          {windowSize >= themeContext.screenSizeWidthWithoutPx.large ? (
            <BarWithSocialMedia />
          ) : (
            <BarWithSocialMediaAndMaczek />
          )}
          <BarWithElements
            color={themeContext.colors.lightGray}
          >
            {t('whereToFindUs')}
          </BarWithElements>
          <MapSection />
        </>
      )}
    </Wrapper>
  );
};

export default ContactLayout;
